<div class="slider-with-inputs">
    <h3>Площ (кв/м.)</h3>
    <app-slider [min]="0" [max]="1000" [step]="1" [value]="1"></app-slider>
    <div class="d-flex align-items-center input-group">
        <app-input [placeholder]="'from'" />
        <span>-</span>
        <app-input [placeholder]="'to'" />
    </div>
</div>
